import request from '@/utils/request'
import {exportFile} from '@/utils/export'
import {uploadFile} from '@/utils/export'
/* 获取订单列表接口 */
export function getOrderList(data) {
  return request({
    url: '/admin/orders/page',
    method: 'get',
	params:data
  })
}
/* 提交订单 */
export function submitOrder(data) {
  return request({
    url: '/admin/order/submit-vendor',
    method: 'post',
    data,
  })
}
/* 退款 */
export function refund(data) {
  return request({
    url: '/admin/order/refund',
    method: 'post',
    data,
  })
}
/* 其他渠道充值*/
export function otherVendorRecharge(data) {
	return request({
	  url: '/admin/order/other-vendor-recharge',
	  method: 'post',
	  data,
	})
	
}
/* 获取订单统计 */
export function getOrderCount(data) {
  return request({
    url: '/admin/order/count',
    method: 'get',
		params:data
  })
}

/* 导出订单列表 */
export function exportOrderList(params) {
  return exportFile('/admin/orders/export',params,'GET');
}

export function getOrderDetail(data){
	return request({
	  url: '/admin/order/detail',
	  method: 'get',
			params:data
	})
}
/* 批量提交订单 */
export function batchSubmitVendor(data) {
	return request({
	  url: '/admin/order/batch-submit-vendor',
	  method: 'post',
	  data,
	})
}
/* 获取订单备注 */
export function getOrderRemark(data) {
	return request({
	  url: '/admin/order/remark',
	  method: 'get',
	  params: data
	})
}
/* 提交订单备注 */
export function orderRemark(data) {
	return request({
	  url: '/admin/order/remark',
	  method: 'post',
	  data,
	})
}


/* 获取省份 */
export function getProvinces(type, data) {
	switch (type) {
		case 3: //水费
			return request({
				url: '/goods/zhike/shuif-provinces/all',
				method: 'get',
				params:data,
			})
			break;
		case 4: //气费
			return request({
				url: '/goods/zhike/ranqi-provinces/all',
				method: 'get',
				params:data,
			})
			break;
		case 0: //电费
			return request({
				url: '/goods/zhike/electric-provinces/all',
				method: 'get',
				params:data,
			})
			break;
	}
	
}


/* 获取城市 */
export function getCitys(type, data) {
	switch (type) {
		case 3: //水费
			return request({
				url: '/goods/zhike/shuif-citys/all',
				method: 'get',
				params:data,
			})
			break;
		case 4: //气费
			return request({
				url: '/goods/zhike/ranqi-citys/all',
				method: 'get',
				params:data,
			})
			break;
		case 0: //电费
			return request({
				url: '/goods/zhike/electric-citys/all',
				method: 'get',
				params:data,
			})
			break;
	}
	
}

/* 获取缴费单位 */
export function getCompanyList(type, data) {
	switch (type) {
		case 3: //水费
			return request({
				url: '/goods/zhike/shuif-companys/all',
				method: 'get',
				params:data,
			})
			break;
	
		case 4: //气费
			return request({
				url: '/goods/zhike/ranqi-companys/all',
				method: 'get',
				params:data,
			})
			break;
	}
}
